import React, { FC, HTMLAttributes } from 'react';

export interface SectionProps extends HTMLAttributes<HTMLDivElement> {}

export const Section: FC<SectionProps> = ({ children, className }) => {
  return <section className={`section ${className}`}>{children}</section>;
};
